package com.evoapps.evoshift.domain.usecase.auth

import com.evoapps.evoshift.domain.model.Capability
import com.evoapps.evoshift.domain.model.capabilitiesAt
import com.evoapps.evoshift.domain.repository.AuthRepository
import kotlinx.coroutines.flow.first

/**
 * What the signed-in person may do at a workplace (Capability.kt). Flows that touch data only some
 * roles may read or write (cost snapshots, daily records, the owner's cost rules) ask first and
 * skip that part, instead of sending a request the server refuses (SH-41): an operational manager
 * publishing a month is not an error, the money figures are a financial manager's to complete.
 */
class CallerCapabilities(private val authRepository: AuthRepository) {
    suspend fun at(workplaceId: String): Set<Capability> =
        authRepository.observeCurrentUser().first()?.capabilitiesAt(workplaceId).orEmpty()

    suspend fun can(workplaceId: String, capability: Capability): Boolean = capability in at(workplaceId)
}

/** True unless [caller] is known and lacks [capability] at [workplaceId] (no gate: allowed, as in tests). */
suspend fun CallerCapabilities?.allows(workplaceId: String, capability: Capability): Boolean =
    this == null || can(workplaceId, capability)
